// extracted by mini-css-extract-plugin
module.exports = {"updateUser":"UpdateUser_updateUser__OOrVU","nameGroup":"UpdateUser_nameGroup__2plJD","formActions":"UpdateUser_formActions__22H-o"};